module.exports = __webpack_public_path__ + "img/tab_icon1.44b46150.png";